import React from 'react';
import PropTypes from 'prop-types';

// components
import { FavoriteIcons } from './FavoriteIcons';
import { Button } from 'dibs-elements/exports/Button';
import TagIcon from 'dibs-vg/dist/react/tag';

// helpers
import classnames from 'classnames';
import { TILE_TYPES } from '../constants';

// styles
import styles from './styles/Overlay.scss';

export function Overlay(props) {
    const {
        className,
        ctaText,
        ctaUrl,
        imageUrl,
        itemCreator,
        itemId,
        tags,
        title,
        userId,
        viewer,
        trackTileClick,
        sharedFavoritesProps,
        tileType,
        showTitleInOverlay,
    } = props;

    const hasTags = tags && !!tags.length;
    const overlayContainerClasses = classnames(styles.overlayContainer, className);
    const overlayClasses = classnames(
        styles.overlay,
        {
            [TILE_TYPES.INTERIORS]: styles.isInteriors,
        }[tileType]
    );
    let tagsEl;
    if (hasTags) {
        tagsEl = (
            <div className={styles.tags}>
                {tags.map(({ name, url }) => (
                    <div className={styles.tag} key={`${name}-${imageUrl}`}>
                        <TagIcon className={styles.tagIcon} />
                        <a
                            className={styles.tagUrl}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {name}
                        </a>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={overlayContainerClasses}>
            <div className={overlayClasses}>
                {itemId && (
                    <FavoriteIcons
                        itemId={itemId}
                        userId={userId}
                        viewer={viewer}
                        imageUrl={imageUrl}
                        title={title}
                        {...sharedFavoritesProps}
                    />
                )}
                {!!itemCreator && <div className={styles.overlayCreator}>{itemCreator}</div>}
                {showTitleInOverlay && <div className={styles.overlayTitle}>{title}</div>}
                {!!ctaText && !!ctaUrl && (
                    <Button
                        size="small"
                        href={ctaUrl}
                        onClick={trackTileClick}
                        opensInNewWindow
                        className={styles.overlayCta}
                    >
                        {ctaText}
                    </Button>
                )}
                {tagsEl}
            </div>
        </div>
    );
}

Overlay.propTypes = {
    className: PropTypes.string,
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
    imageUrl: PropTypes.string,
    trackTileClick: PropTypes.func.isRequired,
    itemCreator: PropTypes.string,
    itemId: PropTypes.string,
    tags: PropTypes.array,
    title: PropTypes.string,
    tileType: PropTypes.string,
    userId: PropTypes.string,
    viewer: PropTypes.object,
    sharedFavoritesProps: PropTypes.object.isRequired,
    showTitleInOverlay: PropTypes.bool,
};
